import { __rest, __assign } from 'tslib';
import { jsx } from '@emotion/react/jsx-runtime';
import { Box } from '../Box/index.js';
import { useTheme } from '../hooks/useTheme.js';
import { useTree } from './hooks/useTree.js';
import { TreeNodes } from './TreeNodes.js';
import { TreeCardProvider } from './TreeProvider.js';

var TreeCard = function (props) {
    var nodeAction = props.nodeAction, size = props.size, _a = props.data, data = _a === void 0 ? [] : _a, _b = props.hideDescription, hideDescription = _b === void 0 ? false : _b, forwardProps = __rest(props, ["nodeAction", "size", "data", "hideDescription"]);
    var treeContext = useTree({
        hideDescription: hideDescription,
        data: data,
        size: size,
        nodeAction: nodeAction,
    });
    var handleStyleProps = useTheme().handleStyleProps;
    var treeStyles = handleStyleProps({ size: size }, { themeKey: "treeCard" }).css;
    return (jsx(Box, __assign({ css: treeStyles }, forwardProps, { children: jsx(TreeCardProvider, __assign({ value: treeContext }, { children: jsx(TreeNodes, { data: treeContext.nodes, context: treeContext }) })) })));
};
TreeCard.displayName = "TreeCard";

export { TreeCard };
//# sourceMappingURL=TreeCard.js.map
